import { render } from "./Services.vue?vue&type=template&id=528b3f89&scoped=true"
const script = {}

import "./Services.vue?vue&type=style&index=0&id=528b3f89&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Zayd\\Documents\\Web Development\\Clients Projects\\RHDesigns\\rhdesigns-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-528b3f89"]])

export default __exports__